module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "footer",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.footer.bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "footer__container"
  }, [(_vm.$route.path != "/" && _vm.showingBanner()) ? _c('div', {
    staticClass: "footer__cta-container"
  }, [_c('Icon', {
    staticClass: "footer__cta-icon",
    attrs: {
      "name": "star"
    }
  }), _c('div', {
    staticClass: "footer__cta-title-wrapper bar_cta"
  }, [(_vm.orthodontic) ? _c('h1', {
    key: "0",
    staticClass: "footer__cta-title"
  }, [_vm._v("Schedule a New Patient Adult or Child Braces/Clear Aligners Exam  ")]) : _vm._e()]), _vm._m(0), _c('div', {
    staticClass: "footer__cta-title-wrapper btn_appointlast"
  }, [(_vm.orthodontic) ? _c('span', {
    key: "0",
    staticClass: "footer__cta-title"
  }, [_vm._v("For new patient pediatric dental appointments please call  ")]) : _vm._e()]), _vm._m(1)], 1) : _vm._e(), _c('div', {
    staticClass: "footer__bottom-container",
    class: {
      'footer__bottom-container--home': _vm.$route.path === '/'
    }
  }, [_c('div', {
    staticClass: "footer__logo-row"
  }, _vm._l((_vm.props.acf.footer.logos), function(logo, i) {
    return _c('img', {
      key: i,
      staticClass: "footer__logo",
      attrs: {
        "title": logo.title,
        "src": logo.url,
        "alt": logo.alt
      }
    })
  }), 0), _c('div', {
    staticClass: "footer__social-row"
  }, _vm._l((_vm.props.acf.social), function(item, i) {
    return _c('a', {
      key: i,
      staticClass: "footer__social-btn",
      attrs: {
        "href": item.href,
        "target": "_blank"
      }
    }, [_c('Icon', {
      staticClass: "footer__social-icon",
      attrs: {
        "name": item.label
      }
    })], 1)
  }), 0), _c('div', {
    staticClass: "footer__site-map"
  }, _vm._l((_vm.links), function(link, j) {
    return (link.navigation) ? _c('div', {
      key: j,
      staticClass: "footer__links",
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name)), _vm._l((link.children), function(sublink, k) {
      return (link.children) ? _c('div', {
        key: k,
        staticClass: "footer__sublinks",
        class: {
          "footer__sublinks--header": sublink.grandchildren
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.handleRoute(sublink)
          }
        }
      }, [_vm._v(_vm._s(sublink.name)), _vm._l((sublink.grandchildren), function(subsublink, l) {
        return (sublink.grandchildren) ? _c('div', {
          key: l,
          staticClass: "footer__subsublinks",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleRoute(subsublink)
            }
          }
        }, [_vm._v(_vm._s(subsublink.name))]) : _vm._e()
      })], 2) : _vm._e()
    })], 2) : _vm._e()
  }), 0)]), _c('div', {
    staticClass: "footer__copyright"
  }, [_vm._v("© 2025 Star Smiles Orthodontics and Pediatric Dentistry ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.name !== 'Home'),
      expression: "$route.name!=='Home'"
    }],
    staticClass: "schedulebtn_outer",
    on: {
      "click": function($event) {
        return _vm.openModal(2)
      }
    }
  }, [_c('div', {
    staticClass: "schedulebtn"
  }, [_vm._v("Schedule a New Patient Appointment         ")])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__appointments-container"
  }, [_c('div', {
    staticClass: "footer__appointments_newbtns"
  }, [_c('a', {
    staticClass: "footer__ortho-consult",
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=psnnsi",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Schedule a new patient consult for adult Braces/Aligners")])]), _c('a', {
    staticClass: "footer__ortho-consult",
    attrs: {
      "href": "https://edgebooking.ortho2.com/search?catalog=140dd719-87c6-4e6f-bc0c-5172cdead16c&code=sbsxfy",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Schedule a new patient consult for Kids Braces")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer__appointments-container"
  }, [_c('div', {
    staticClass: "footer__appointments_newbtns phonenew"
  }, [_c('a', {
    staticClass: "footer__ortho-consult",
    attrs: {
      "href": "tel:1-630-980-8800"
    }
  }, [_c('span', [_vm._v("(630) 980-8800                           ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d4675b0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 679
// module chunks = 1